<a class="back-btn" (click)="goBack()">
    <div class="navigate">
        <i class="pi pi-chevron-left"></i>
    </div>
   <span>Voltar</span> 
</a>